/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function DefaultAvatar({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 62 62" {...props}><g fill="none" fillRule="evenodd"><path fill="currentColor" fillOpacity={0.17} fillRule="nonzero" d="M30.989 60c16.562 0 29.988-13.208 29.988-29.5S47.551 1 30.989 1C14.426 1 1 14.208 1 30.5S14.426 60 30.989 60" /><path stroke="currentColor" strokeWidth={4} d="M58.977 30.5c0 15.157-12.5 27.5-27.988 27.5C15.499 58 3 45.657 3 30.5S15.5 3 30.989 3c15.488 0 27.988 12.343 27.988 27.5z" /><path fill="currentColor" fillRule="nonzero" d="M23.171 23c0 6.79-5.804 6.79-5.804 0s5.804-6.82 5.804 0m20.403 0c0 6.79-5.805 6.79-5.805 0s5.805-6.82 5.805 0M33.66 45a16.2 16.2 0 0 1-3.734-.433c-.303-.07-.57-.283-.743-.589a1.62 1.62 0 0 1-.179-1.045c.06-.362.237-.682.493-.889s.57-.284.873-.214c3.702.834 7.53.243 10.935-1.69a.99.99 0 0 1 .896-.062c.145.062.279.157.393.28.115.123.208.272.274.439a1.65 1.65 0 0 1 .047 1.076 1.5 1.5 0 0 1-.237.47 1.2 1.2 0 0 1-.37.325C39.606 44.204 36.652 45 33.661 45z" /></g></svg>;
}
;